import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JumbleCoreService } from './jumble-core.service';
import { JumbleSelectorComponent } from './jumble-selector/jumble-selector.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [JumbleSelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [JumbleCoreService],
  exports: [JumbleSelectorComponent],
})
export class JumbleCoreModule {}
